module.exports = __webpack_public_path__ + "static/media/055.dd28186b.jpg";